import type { PropsWithChildren, ReactNode } from 'react'
import Animated from 'react-native-reanimated'

import { useAnimatedSearchBar } from './useAnimatedSearchBar'

export const AnimatedSearchBar = ({ children }: PropsWithChildren): ReactNode => {
  const { animatedStyles, measureView } = useAnimatedSearchBar()
  return (
    <Animated.View style={animatedStyles} onLayout={measureView}>
      {children}
    </Animated.View>
  )
}
